import { render, staticRenderFns } from "./calendar-person-picker.vue?vue&type=template&id=400fb567&"
import script from "./calendar-person-picker.vue?vue&type=script&lang=ts&"
export * from "./calendar-person-picker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports